module.exports = __webpack_public_path__ + "img/consult.db758197.jpg";